export const MAX_ERROR_REQUESTS_COUNT = 5
export const RETRY_429_BASE_DELAY_MS = 300
export const RETRY_429_MAX_DELAY_MS = 8000
export const TOO_MANY_REQUESTS_ERROR_MESSAGE =
    'You overloaded the server with requests. Please wait a few seconds and try again.'
